export default __webpack_public_path__ + "static/media/HOME_BANNER.e396cf4e.png";